import React from 'react';
import type { TimelineEpic } from '@/types';
import TimelineRow from './TimelineRow';

interface TimelineGridProps {
  epics: TimelineEpic[];
  selectedYear: number;
}

const TimelineGrid: React.FC<TimelineGridProps> = ({ epics, selectedYear }) => {
  const months = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ];

  return (
    <div className="bg-[var(--surface)] border border-[var(--border)] rounded-lg overflow-hidden">
      {/* Header Row */}
      <div className="grid grid-cols-[250px_100px_1fr] border-b border-[var(--border)] bg-[var(--surface-muted)] sticky top-0 z-10">
        {/* Epic Column Header */}
        <div className="p-3 font-semibold text-[var(--text)] border-r border-[var(--border)]">
          Epics
        </div>

        {/* OKR Column Header */}
        <div className="p-3 font-semibold text-[var(--text)] border-r border-[var(--border)]">
          OKRs
        </div>

        {/* Timeline Month Headers */}
        <div className="grid grid-cols-12">
          {months.map((month, index) => (
            <div
              key={month}
              className={`p-3 text-center font-semibold text-[var(--text)] ${
                index < 11 ? 'border-r border-[var(--border)]' : ''
              }`}
            >
              {month}
            </div>
          ))}
        </div>
      </div>

      {/* Timeline Rows */}
      <div className="divide-y divide-[var(--border)]">
        {epics.map((epic) => (
          <TimelineRow key={epic.id} epic={epic} selectedYear={selectedYear} />
        ))}
      </div>
    </div>
  );
};

export default TimelineGrid;
